export enum PasswordStrength {
  veryLow = 'very-low',
  low = 'low',
  medium = 'medium',
  strength = 'strength',
  veryStrength = 'very-strength'
}
